import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { default as IconComponent } from '../../-private/components/link-or-button-icon.gts';
import type { Signature as IconSignature } from '../../-private/components/link-or-button-icon';
export interface Signature {
    Element: HTMLAnchorElement;
    Args: {
        // See https://steveholgado.com/typescript-types-from-arrays to understand this type
        variant?: (typeof VALID_VARIANTS)[number];
        icon?: IconSignature['Args']['icon'];
    };
    Blocks: {
        default: [];
    };
}
export const VALID_VARIANTS = [
    'link',
    'inverted',
    'primary-btn',
    'outlined-btn',
    'outlined-mini-btn'
] as const; // See [const assertions](https://www.typescriptlang.org/docs/handbook/release-notes/typescript-3-4.html#const-assertions) to know why we need `as const`
export const STYLES = {
    base: [
        'inline-block'
    ],
    link: [
        'hover:underline',
        'hover:text-black',
        'focus:underline',
        'focus:text-pink',
        'focus:outline-none'
    ],
    inverted: [
        'text-white',
        'hover:underline',
        'focus:underline',
        'focus:text-purple',
        'focus:outline-none'
    ],
    'primary-btn': [
        'active:bg-gradient-to-r',
        'active:disabled:bg-none',
        'active:from-purple',
        'active:to-pink',
        'bg-pink',
        'border-pink',
        'border',
        'focus-visible:border-purple',
        'focus-visible:outline-2',
        'focus-visible:outline-offset-0',
        'focus-visible:outline-purple',
        'focus-visible:outline',
        'font-sans',
        'gap-2',
        'hover:no-underline',
        'hover:shadow',
        'inline-flex',
        'items-center',
        'justify-center',
        'px-4',
        'py-2',
        'rounded-md',
        'text-p1',
        'text-white'
    ],
    'outlined-btn': [
        '[&>svg]:text-grey',
        'active:bg-gradient-to-r',
        'active:disabled:bg-none',
        'active:from-grey-medium',
        'active:to-white',
        'bg-white',
        'border-grey-medium',
        'border',
        'focus-visible:border-black',
        'focus-visible:outline-2',
        'focus-visible:outline-black',
        'focus-visible:outline-offset-0',
        'focus-visible:outline',
        'font-sans',
        'gap-2',
        'hover:no-underline',
        'hover:shadow',
        'hover:text-black',
        'inline-flex',
        'items-center',
        'justify-center',
        'px-4',
        'py-2',
        'rounded-md',
        'text-p1'
    ],
    'outlined-mini-btn': [
        '[&>svg]:text-grey',
        '[&>svg]:w-6',
        '[&>svg]:h-6',
        'active:from-grey-medium',
        'active:to-white',
        'bg-white',
        'hover:bg-grey-medium',
        'rounded-md',
        'focus-visible:outline-2',
        'focus-visible:outline-offset-0',
        'focus-visible:outline',
        'focus-visible:outline-black',
        'border-none',
        'p-1'
    ]
} as const;
export default class WrAnchorComponent extends Component<Signature> {
    get variant() {
        return this.args.variant || 'link';
    }
    get styles() {
        return [
            ...STYLES.base,
            ...STYLES[this.variant]
        ].join(' ');
    }
    static{
        template(`
    <a class={{this.styles}} ...attributes>
      <IconComponent @icon={{@icon}} />
      {{yield}}
    </a>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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-c3ZnXTp0ZXh0LWdyZXknLFxuICAgICdbJj5zdmddOnctNicsXG4gICAgJ1smPnN2Z106aC02JyxcbiAgICAnYWN0aXZlOmZyb20tZ3JleS1tZWRpdW0nLFxuICAgICdhY3RpdmU6dG8td2hpdGUnLFxuICAgICdiZy13aGl0ZScsXG4gICAgJ2hvdmVyOmJnLWdyZXktbWVkaXVtJyxcbiAgICAncm91bmRlZC1tZCcsXG4gICAgJ2ZvY3VzLXZpc2libGU6b3V0bGluZS0yJyxcbiAgICAnZm9jdXMtdmlzaWJsZTpvdXRsaW5lLW9mZnNldC0wJyxcbiAgICAnZm9jdXMtdmlzaWJsZTpvdXRsaW5lJyxcbiAgICAnZm9jdXMtdmlzaWJsZTpvdXRsaW5lLWJsYWNrJyxcbiAgICAnYm9yZGVyLW5vbmUnLFxuICAgICdwLTEnXG4gIF1cbn0gYXMgY29uc3Q7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFdyQW5jaG9yQ29tcG9uZW50IGV4dGVuZHMgQ29tcG9uZW50PFNpZ25hdHVyZT4ge1xuICBnZXQgdmFyaWFudCgpIHtcbiAgICByZXR1cm4gdGhpcy5hcmdzLnZhcmlhbnQgfHwgJ2xpbmsnO1xuICB9XG5cbiAgZ2V0IHN0eWxlcygpIHtcbiAgICByZXR1cm4gWy4uLlNUWUxFUy5iYXNlLCAuLi5TVFlMRVNbdGhpcy52YXJpYW50XV0uam9pbignICcpO1xuICB9XG5cbiAgPHRlbXBsYXRlPlxuICAgIDxhIGNsYXNzPXt7dGhpcy5zdHlsZXN9fSAuLi5hdHRyaWJ1dGVzPlxuICAgICAgPEljb25Db21wb25lbnQgQGljb249e3tAaWNvbn19IC8-XG4gICAgICB7e3lpZWxkfX1cbiAgICA8L2E-XG4gIDwvdGVtcGxhdGU-XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sZUFBZSxxQkFBcUI7QUFDM0MsU0FBUyxXQUFXLGFBQWEsUUFBUSxvREFBb0Q7QUFDN0YsY0FBYyxhQUFhLGFBQWEsUUFBUSxnREFBZ0Q7QUFFaEcsaUJBQWlCO0lBQ2YsU0FBUztJQUNUO1FBQ0Usb0ZBQW9GO1FBQ3BGLGtCQUFrQixnQkFBZ0IsTUFBTTtRQUN4QyxPQUFPLGNBQWMsUUFBUTs7SUFFL0I7UUFDRTs7O0FBSUosT0FBTyxNQUFNLGlCQUFpQjtJQUM1QjtJQUNBO0lBQ0E7SUFDQTtJQUNBO0NBQ0QsVUFBVSxDQUFDLHlKQUF5SjtBQUVySyxPQUFPLE1BQU0sU0FBUztJQUNwQixNQUFNO1FBQUM7S0FBZTtJQUN0QixNQUFNO1FBQ0o7UUFDQTtRQUNBO1FBQ0E7UUFDQTtLQUNEO0lBQ0QsVUFBVTtRQUNSO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7S0FDRDtJQUNELGVBQWU7UUFDYjtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7S0FDRDtJQUNELGdCQUFnQjtRQUNkO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO0tBQ0Q7SUFDRCxxQkFBcUI7UUFDbkI7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtRQUNBO1FBQ0E7UUFDQTtLQUNEO0FBQ0gsV0FBVztBQUVYLGVBQWUsTUFBTSwwQkFBMEIsVUFBVTtJQUN2RCxJQUFJLFVBQVU7UUFDWixPQUFPLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTyxJQUFJO0lBQzlCO0lBRUEsSUFBSSxTQUFTO1FBQ1gsT0FBTztlQUFJLE9BQU8sSUFBSTtlQUFLLE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDO1NBQUMsQ0FBQyxJQUFJLENBQUM7SUFDeEQ7SUFFQSxNQUFBO1FBQUEsU0FBVSxDQUFBOzs7OztFQUtWLENBQUEsRUFBQTtZQUFBLFdBQUEsSUFBVztZQUFYO2dCQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztZQUFEO1FBQUE7SUFBQSxDQUxBO0FBTVoifQ